@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.prompt {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: auto;
  min-height: 24px;
  padding: 24px 8px;
  width: 100%;

  @include breakpoints.desktop {
    flex-direction: row;
    justify-content: center;
    padding: 12px 0;
    height: auto;
    min-height: 0;
  }
}

.promptHeadline {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  float: left;
  color: #231F20;
  font-family: typography.$font-mont;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #143467;
  min-width: 0;
  white-space: normal;

  > img {
    margin-right: 0.5em;
  }

  margin-right: 0.5em;
  margin-bottom: 0;

  @include breakpoints.desktop {
    font-size: 16px;
    white-space: nowrap;
  }
}

.somethingWentWrong {
  color: var(--red);
}

.modal {
  max-width: 607px;
  max-height: calc(100vh - 50px);
  height: calc(100vh - 50px);
}

.modalOverlay {
  align-items: initial;
}

.hideBackground {
  z-index: 1;
  background-color: #ECE8DC;
  padding: 0px 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 100%;
  row-gap: 4px;
  white-space: normal;

  @include breakpoints.desktop {
    position: relative;
    top: -25px;
    flex-wrap: nowrap;
    white-space: nowrap;
  }
}

.joinWaitlistButton {
  font-family: Montserrat;
  font-weight: 600;
  font-style: normal;
  font-size: clamp(14px, 3.8vw, 16px);
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;
}
